/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Static-mode replacement for the `i18next` value imports used by `root.tsx`
 * (`createInstance`). Aliased in for `I18N_MODE=static` via `@/lib/i18n-compat`
 * so the real `i18next` core never enters the client bundle. Returns the shared
 * English shim instance; `.use()/.init()` are inert.
 */
import { staticI18nInstance, type StaticI18n } from './react-i18next-shim';

/** Type alias mirroring i18next's `i18n` type name for call-site compatibility. */
export type i18n = StaticI18n;

export function createInstance(): StaticI18n {
    return staticI18nInstance;
}
